import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav_home: 'Home',
      nav_about: 'About Us',
      nav_services: 'Services',
      nav_destinations: 'Destinations',
      nav_blog: 'Blog',
      nav_contact: 'Contact Us',
      cta_quote: 'Get a Quote',
      cta_contact: 'Contact Us',
      hero_title: 'Your journey starts in Dakar, lands anywhere.',
      hero_subtitle: 'Budget-friendly flights, luxury stays, and holidays built around you.',
      footer_rights: 'All rights reserved.'
    }
  },
  fr: {
    translation: {
      nav_home: 'Accueil',
      nav_about: 'À propos',
      nav_services: 'Services',
      nav_destinations: 'Destinations',
      nav_blog: 'Blog',
      nav_contact: 'Contactez-nous',
      cta_quote: 'Obtenir un devis',
      cta_contact: 'Contactez-nous',
      hero_title: "Votre voyage commence à Dakar, atterrit n'importe où.",
      hero_subtitle: 'Vols économiques, séjours de luxe et vacances sur mesure.',
      footer_rights: 'Tous droits réservés.'
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('bj_lang') || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }
});

export default i18n;
